import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { Typography } from '@cp/ds/src/components/typography';
import { Button } from '@cp/ds/src/components/button';
import { Grid } from '@cp/ds/src/components/grid';
import { Stack } from '@cp/ds/src/components/stack';
import { useIsMobile, useTheme } from '@cp/ds/src/hooks';
import { ArrowRightIcon } from '@cp/ds/src/icons';
import { ContentSkeleton } from '@cp/ds/src/components/contentSkeleton';
import { Image as Img } from '@cp/ui';
import { useBlogPosts } from '../model/useBlogPosts';

export const BannerBlogPosts: React.FC = () => {
  const { posts, media, loading } = useBlogPosts();
  const theme = useTheme();
  const isMobile = useIsMobile();

  if (loading) {
    return (
      <Grid
        container
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: 1.5, md: 2.5 },
          flexWrap: 'nowrap',
        }}
      >
        {new Array(3).fill(null).map((_, k) => (
          <Grid item key={k} md={4} xs={12}>
            <ContentSkeleton blocks={3} />
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Grid
        container
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: 1.5, md: 2.5 },
          mb: { xs: 1.5, md: 2.5 },
          flexWrap: 'nowrap',
        }}
      >
        {posts?.map((post) => (
          <Grid
            item
            key={post.id}
            md={4}
            sx={{
              borderRadius: `${theme.borderRadius.large}px`,
              overflow: 'hidden',
            }}
            xs={12}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: 250, overflow: 'hidden' }}>
              <Img
                alt={post.title.rendered}
                src={media[post.id]}
                sx={{
                  width: '120%',
                  height: 'auto',
                }}
              />
            </Box>
            <Stack
              gap={{ xs: 1.5, md: 2.5 }}
              sx={{
                pt: { xs: 1.5, md: 2.5 },
                pl: { xs: 1.5, md: 3.75 },
                pr: { xs: 1.5, md: 3.75 },
                pb: { xs: 1.5, md: 3.75 },
                backgroundColor: theme.palette.white,
              }}
            >
              <Typography variant="h3">{post.title.rendered}</Typography>
              <Typography
                dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }}
                sx={{
                  display: '-webkit-box',
                  '-webkit-line-clamp': '3',
                  '-webkit-box-orient': 'vertical',
                  overflow: 'hidden',
                  '& p': { m: 0 },
                }}
              />
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography variant="caption">Аверин Валерий</Typography>
                <Typography sx={{ color: theme.palette.gray }} variant="small text">
                  Педагог, врач высшей категории
                </Typography>
              </Box>
            </Stack>
          </Grid>
        ))}
      </Grid>

      <Button
        color="white"
        iconRight={<ArrowRightIcon />}
        onClick={() => window.open('https://youhelp.ru/blog/category/dlja-njan-i-roditelej', '_blank', 'noopener,noreferrer')}
        size={isMobile ? 'small' : 'normal'}
      >
        Показать все
      </Button>
    </Box>
  );
};
